import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const boxStyle: SxProps<Theme> = {
  height: '690px',
};
